var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectordown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 408,
    viewBox: "0 0 518 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-260.988 517.845V399.507H-192.549V517.845C-192.549 521.803 -189.269 525.022 -185.268 525.022H270.997H271.497V524.522V354.857C271.497 341.22 260.227 330.134 246.396 330.134H-362.886C-366.887 330.134 -370.167 333.352 -370.167 337.311V629.126C-370.167 631.028 -369.371 632.81 -368.02 634.14L-214.793 785.068C-213.383 786.456 -211.574 787.179 -209.606 787.179H246.449C260.279 787.179 271.549 776.093 271.549 762.456V661.664H339.988V762.456C339.988 813.206 298.062 854.5 246.501 854.5H-209.553C-229.871 854.5 -248.878 846.735 -263.134 832.647L-263.134 832.646L-416.36 681.823C-430.617 667.682 -438.5 648.969 -438.5 629.074V337.259C-438.5 296.136 -404.512 262.709 -362.781 262.709H-261.488H-260.988V262.209V75.0499C-260.988 33.9267 -226.999 0.5 -185.268 0.5H281.194C306.138 0.5 329.665 10.0764 347.285 27.4773L347.286 27.4777L489.994 168.049L490.01 168.08L490.047 168.152L490.105 168.209C507.777 185.611 517.5 208.774 517.5 233.328V500.35C517.5 551.101 475.574 592.395 424.014 592.395H-185.268C-227.051 592.395 -260.988 558.917 -260.988 517.845ZM-192.102 262.761H245.229L245.176 262.812H246.396C297.957 262.812 339.883 304.106 339.883 354.857V524.522V525.022H340.383H423.909C437.739 525.022 449.009 513.936 449.009 500.298V233.276C449.009 226.722 446.378 220.488 441.66 215.79L441.658 215.788L298.892 75.1596C294.172 70.5127 287.896 67.9249 281.194 67.9249H-185.321C-189.322 67.9249 -192.602 71.1434 -192.602 75.1017V262.261V262.761H-192.102Z",
    stroke: "url(#paint0_linear_47_15494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_15494",
    x1: 39.5001,
    y1: -280.893,
    x2: 39.5001,
    y2: 468.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D8F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8F50",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectordown);
export default __webpack_public_path__ + "static/media/Vectordown.1013482b2956dce906fb6ba0a719787f.svg";
export { ForwardRef as ReactComponent };